<script>
import { api } from "@/state/services";

export default {
  beforeCreate() {
    document.body.className = "auth";
  },
  data() {
    return {
      uuid: this.$route.params.uuid,

      ownerLoading: true,
      owner: null,
      ownerError: "",

      step: "intro",

      submitting: false,
      groupLink: "",
      formError: "",

      form: {
        name:     "",
        telefone: "",
        email:    "",
      },
    };
  },
  created() {
    api.get("apn/cadastro/" + this.uuid).then((r) => {
      if (r.data && r.data.status === "success") {
        this.owner = r.data.owner;
      } else {
        this.ownerError = (r.data && r.data.message) || "Link de convite inválido ou expirado.";
      }
    }).catch((err) => {
      const status = err && err.response && err.response.status;
      if (status === 403) {
        this.ownerError = "Este link de convite não está disponível no momento.";
      } else {
        this.ownerError = "Não foi possível carregar as informações do convite.";
      }
    }).finally(() => { this.ownerLoading = false; });
  },
  methods: {
    proceedToForm() {
      this.step = "form";
    },

    handleSubmit() {
      this.formError = "";
      if (!this.form.name.trim() || !this.form.telefone.trim() || !this.form.email.trim()) {
        this.formError = "Preencha todos os campos.";
        return;
      }
      this.submitting = true;
      api.post("apn/cadastro/" + this.uuid, { ...this.form }).then((r) => {
        if (r.data && r.data.status === "success") {
          this.groupLink = r.data.group_link || "";
          this.step      = "success";
        } else {
          this.formError = (r.data && r.data.message) || "Erro ao realizar cadastro.";
        }
      }).catch(() => {
        this.formError = "Erro ao realizar cadastro. Tente novamente.";
      }).finally(() => { this.submitting = false; });
    },
  },
};
</script>

<template>
  <div class="cad-page">
    <div class="cad-wrap">

      <!-- Loading -->
      <div v-if="ownerLoading" class="text-center py-5">
        <b-spinner variant="secondary"></b-spinner>
      </div>

      <!-- Erro de link -->
      <div v-else-if="ownerError" class="cad-card text-center py-5">
        <i class="mdi mdi-link-variant-off" style="font-size:3rem;color:var(--st-danger);"></i>
        <p class="mt-3 text-danger font-weight-bold mb-0">{{ ownerError }}</p>
      </div>

      <!-- Conteúdo principal -->
      <div v-else>

        <!-- Logo + quem convidou -->
        <div class="cad-header">
          <img src="@/assets/images/logo.png" alt="Sales Teams" />
          <p class="cad-subtitle" v-if="owner">
            Você foi convidado por <strong>{{ owner.name }}</strong>
          </p>
        </div>

        <!-- Etapa 1: texto de avanço na triagem + botão -->
        <template v-if="step === 'intro'">
          <div class="vip-card">
            <div class="vip-alert">
              🎉 <strong>Sua candidatura avançou para a próxima etapa.</strong>
            </div>

            <p class="vip-intro">
              <strong>Parabéns!</strong><br>
              Seu cadastro foi aprovado na triagem inicial e você está apto(a) a participar
              da próxima fase do Processo Seletivo APN.
            </p>

            <p class="vip-intro">
              Antes da entrevista e da apresentação da oportunidade, nossa equipe utilizará
              um canal oficial para compartilhar todas as informações necessárias.
            </p>

            <p class="vip-section-title">Neste grupo você terá acesso a:</p>
            <ul class="vip-list">
              <li>✅ Orientações sobre cada etapa do processo</li>
              <li>✅ Datas e horários das apresentações</li>
              <li>✅ Informações sobre a função e o plano de carreira</li>
              <li>✅ Materiais de apoio</li>
              <li>✅ Comunicação direta com a equipe de recrutamento</li>
            </ul>

            <div class="vip-warning">
              ⚠️ <strong>Importante:</strong> este grupo é destinado exclusivamente aos
              candidatos aprovados na triagem inicial e permanecerá ativo durante o ciclo
              do processo seletivo.
            </div>
          </div>

          <b-button
            block
            class="cad-submit"
            style="font-size:16px;padding:14px;"
            @click="proceedToForm"
          >
            Prosseguir para a próxima etapa
          </b-button>
        </template>

        <!-- Card do formulário / sucesso -->
        <div v-else class="cad-card">

          <!-- Sucesso -->
          <div v-if="step === 'success'" class="text-center py-3">
            <h4 class="font-weight-bold">Parabéns, {{ form.name }}!</h4>
            <p class="text-muted mb-4">
              Falta pouco para garantir sua vaga, clique no link abaixo para acessar o grupo exclusivo do Teams.
            </p>
            <a
              v-if="groupLink"
              :href="groupLink"
              target="_blank"
              class="btn btn-block cad-submit"
              style="font-size:16px;padding:14px;"
            >
              <i class="mdi mdi-whatsapp mr-2"></i> Acessar Grupo Exclusivo
            </a>
            <p v-else class="text-muted small mt-3">
              Aguarde o contato do responsável pelo convite.
            </p>
          </div>

          <!-- Formulário -->
          <b-form v-else @submit.prevent="handleSubmit">
            <p class="cad-form-title">👇 Garanta sua vaga agora</p>

            <div v-if="formError" class="alert alert-danger py-2 small mb-3">{{ formError }}</div>

            <b-form-group label="Nome completo *">
              <b-form-input
                v-model="form.name"
                placeholder="Seu nome completo"
                required
                :disabled="submitting"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Telefone / WhatsApp *">
              <b-form-input
                v-model="form.telefone"
                type="tel"
                placeholder="(00) 00000-0000"
                required
                :disabled="submitting"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="E-mail *">
              <b-form-input
                v-model="form.email"
                type="email"
                placeholder="seu@email.com"
                required
                :disabled="submitting"
              ></b-form-input>
            </b-form-group>

            <b-button
              type="submit"
              class="cad-submit mt-2"
              block
              :disabled="submitting"
            >
              <b-spinner v-if="submitting" small class="mr-1"></b-spinner>
              {{ submitting ? "Aguarde…" : "Garantir Minha Vaga 🔥" }}
            </b-button>
          </b-form>

        </div>

        <p class="cad-footer">&copy; {{ new Date().getFullYear() }} Sales Teams</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* ── BASE ─────────────────────────────────────────────────────── */
.cad-page {
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(170deg, var(--st-brand-start) 0%, var(--st-brand) 50%, #1e3a5f 100%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 16px 64px;
  box-sizing: border-box;
}
.cad-wrap {
  width: 100%;
  max-width: 480px;
}

/* ── HEADER ───────────────────────────────────────────────────── */
.cad-header {
  text-align: center;
  margin-bottom: 20px;
}
.cad-header img {
  max-width: 160px;
  width: 100%;
  filter: brightness(0) invert(1);
}
.cad-subtitle {
  color: rgba(255, 255, 255, 0.8);
  margin-top: 8px;
  margin-bottom: 0;
  font-size: .88rem;
}

/* ── VIP CARD (mensagem de destaque) ──────────────────────────── */
.vip-card {
  background: linear-gradient(135deg, #0d1f0d 0%, #1a3a1a 100%);
  border: 1px solid rgba(39, 174, 96, 0.35);
  border-radius: var(--st-radius-lg);
  padding: 22px 20px;
  margin-bottom: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,.35);
}
.vip-alert {
  background: rgba(231, 76, 60, 0.15);
  border: 1px solid rgba(231, 76, 60, 0.4);
  border-radius: var(--st-radius-sm);
  padding: 12px 14px;
  font-size: .9rem;
  color: #ff6b6b;
  text-align: center;
  margin-bottom: 16px;
  line-height: 1.5;
}
.vip-intro {
  color: rgba(255,255,255,.88);
  font-size: .88rem;
  line-height: 1.65;
  margin-bottom: 14px;
}
.vip-section-title {
  color: #2ecc71;
  font-size: .82rem;
  font-weight: 700;
  letter-spacing: .03em;
  text-transform: uppercase;
  margin-bottom: 10px;
}
.vip-list {
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
}
.vip-list li {
  color: rgba(255,255,255,.85);
  font-size: .88rem;
  padding: 5px 0;
  border-bottom: 1px solid rgba(255,255,255,.06);
  line-height: 1.5;
}
.vip-list li:last-child {
  border-bottom: none;
}
.vip-warning {
  background: rgba(243, 156, 18, 0.12);
  border: 1px solid rgba(243, 156, 18, 0.35);
  border-radius: var(--st-radius-sm);
  padding: 10px 14px;
  font-size: .84rem;
  color: #f1c40f;
  text-align: center;
  line-height: 1.5;
}

/* ── FORM CARD ────────────────────────────────────────────────── */
.cad-card {
  background: var(--st-surface);
  border-radius: var(--st-radius-lg);
  box-shadow: var(--st-shadow-lg);
  padding: 28px 24px;
}
.cad-form-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--st-brand);
  text-align: center;
  margin-bottom: 20px;
}
.cad-submit {
  background: #27ae60;
  border-color: #27ae60;
  color: var(--st-text-inverse);
  font-weight: 700;
  padding: .75rem;
  border-radius: var(--st-radius-sm);
  font-size: 15px;
  letter-spacing: .02em;
}
.cad-submit:hover:not(:disabled) {
  background: #219150;
  border-color: #219150;
}

/* ── FOOTER ───────────────────────────────────────────────────── */
.cad-footer {
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: .75rem;
  margin-top: 20px;
  margin-bottom: 0;
}

/* ── MOBILE ───────────────────────────────────────────────────── */
@media (max-width: 480px) {
  .cad-page    { padding: 24px 12px 48px; }
  .cad-card    { padding: 22px 16px; }
  .vip-card    { padding: 18px 14px; }
  .vip-alert   { font-size: .84rem; padding: 10px 12px; }
  .vip-list li { font-size: .84rem; }
  .vip-intro   { font-size: .84rem; }
}
</style>
